import { connect } from 'react-redux';

import { actionGetBookingDetail } from 'store/booking/actions';
import {
  APPROVE_BOOKING,
  REJECT_BOOKING,
  REFUND_BOOKING,
  OTA_SYNC_BOOKING,
} from 'store/booking/actionTypes';

import BookingDetail from './BookingDetail';

const mapStateToProps = (state) => ({
  isLoadingApproveBooking: state.Booking.isLoadingApproveBooking,
  isLoadingCancelBooking: state.Booking.isLoadingCancelBooking,
  isLoadingRefundBooking: state.Booking.isLoadingRefundBooking,
  isLoadingOtaSyncBooking: state.Booking.isLoadingOtaSyncBooking,
  bookingDetail: state.Booking.bookingDetail,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetBookingDetail: (payload) => dispatch(actionGetBookingDetail(payload)),

  actionApproveBooking: (payload) => dispatch({
    payload,
    type: APPROVE_BOOKING,
  }),

  actionCancelBooking: (payload) => dispatch({
    payload,
    type: REJECT_BOOKING,
  }),

  actionRefundBooking: (payload) => dispatch({
    payload,
    type: REFUND_BOOKING,
  }),

  actionOtaSyncBooking: (payload) => dispatch({
    payload,
    type: OTA_SYNC_BOOKING,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(BookingDetail);
